import React, { forwardRef } from 'react'
import { useAppSelector } from '../../../../../../../../../../app/hooks'
import { InitState } from '../../../../../../../../../../redux/reducers/root/initialState'
import { AttachmentType } from '../../../../../../../../../../@types/types'
import { WebViewMultimediaPreview } from './WebViewMultimediaPreview'
import { InitialUploadClickableArea } from './InitialUploadClickableArea'
import { PicturesUploadTip } from './PicturesUploadTip'

interface MobileMultimediaButtonProps {
  dropzoneId: string
  onFilesSelected: (files: FileList) => void
  showUploadTip?: boolean
}

export const WebViewMultimediaButton = forwardRef<HTMLDivElement, MobileMultimediaButtonProps>(
  ({ dropzoneId, onFilesSelected, showUploadTip = false }, ref) => {
    const attachments = useAppSelector((state: InitState) => state.multimediaFeature.attachments || [])

    // Check if there are any picture attachments with URLs
    const hasPictures = attachments.some(
      (attachment) => attachment.attachmentType === AttachmentType.PICTURE && attachment.attachment?.url
    )

    if (hasPictures) {
      return <WebViewMultimediaPreview dropzoneId={dropzoneId} pluploadRef={ref} onFilesSelected={onFilesSelected} />
    }

    return (
      <>
        <InitialUploadClickableArea dropzoneId={dropzoneId} pluploadRef={ref} />
        {showUploadTip && <PicturesUploadTip pictureCount={0} />}
      </>
    )
  }
)
